import { useMutation } from 'react-query';

import { ResolveFactDocIdsResponseDto } from '../../../../backend/src/matter/fact/dto/resolve-fact-doc-ids.dto';
import { APIBaseChronos } from '../hosts';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

export const useResolveFactDocIds = () => {
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation({
    mutationFn: async ({ matterId, factIds }: { matterId: string; factIds: string[] }) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.POST,
        data: { factIds },
      });

      const res = await fetch(`${APIBaseChronos}/api/matter/${matterId}/fact/resolve-doc-ids`, fetchConfig);

      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw new Error(errorData.message || `Failed to resolve fact doc IDs: ${res.statusText}`);
      }

      return res.json() as Promise<ResolveFactDocIdsResponseDto>;
    },
  });
};
